import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";

export const primaryCheckboxStyles = {
  ".MuiCheckbox-root": {
    ":not(.Mui-disabled)": {
      color: "#00B0F5",
    },
  },
};

export const CheckBox = ({
  handler,
  isChecked,
  indeterminate = false,
  disabled = false,
}) => {
  return (
    <FormControlLabel
      sx={{ margin: "0px", ...primaryCheckboxStyles }}
      control={
        <Checkbox
          onChange={(e) =>
            handler(e.target.checked ? true : false)
          }
          // sx={{ paddingTop: "0px" }}
          name="emailEnabled"
          checked={isChecked}
          disabled={disabled}
          indeterminate={indeterminate}
        />
      }
    />
  );
};
